export default __webpack_public_path__ + "navigation-examples-building-extrusion-v1-1200-d257da78c7646bf2c25c1754dcbd87a9.webp";